module.exports = __webpack_public_path__ + "static/media/independent-practice.0c0d9467.md";